function StringStartsWithPolyfill(search, pos) {
  return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
};


module.exports = String.prototype.startsWith || StringStartsWithPolyfill;



//////////////////
// WEBPACK FOOTER
// ./polyfills/string-startsWith.js
// module id = 718
// module chunks = 0